import GEO from "assets/country_flags/georgia.png"
import US from "assets/country_flags/united-states.png"

export const getCountryFlag = (countryKey: string): string => {
  switch (countryKey) {
    case "ka":
      return GEO
    case "en":
      return US
    default:
      return ""
  }
}
